var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { environment } from '@env/environment';
var KnowledgeBaseComponent = /** @class */ (function () {
    function KnowledgeBaseComponent(util, apiService) {
        this.util = util;
        this.apiService = apiService;
        this.Search = null;
        this.showingKBList = [];
        this.Editable = true;
        this.searchType = "k";
        this.isCrisis = false;
        this.config = {};
        this.categoryList = [];
        this.submittedKB = false;
        this.createType = "";
        this.createTitle = "";
        this.createKeyword = "";
        this.createContent = "";
        this.role = {};
        this.FileList = [];
    }
    KnowledgeBaseComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, TableDocs, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        thisTs = this;
                        this.util.ShowWaiting(true);
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        this.role = JSON.parse(this.cookieData.role);
                        this.isCrisis = this.cookieData.isCrisis;
                        $('#date').datepicker({
                            //inline: true
                            language: 'th-th',
                        }).on('changeDate', function (e) {
                            thisTs.util.ShowWaiting(true);
                            thisTs.Search = "";
                            thisTs.showingKBList = thisTs.knowledgeList.filter(function (kb) {
                                return moment(e.date).format("YYYY-MM-DD") === kb.modifiedon.substring(0, 10);
                            });
                            thisTs.formatAttachmentName();
                            thisTs.util.ShowWaiting(false);
                        });
                        TableDocs = $('#TableDocs');
                        TableDocs.on('click', 'tbody tr td [role=view]', function () {
                            thisTs.ViewFile($(this).attr('url'), $(this).attr('filename'));
                        });
                        TableDocs.on('click', 'tbody tr td [role=delete]', function () {
                            thisTs.DeleteFile($(this).attr('filename'));
                        });
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("master", "knowledgebasecategory")];
                    case 1:
                        _a.categoryList = _b.sent();
                        return [4 /*yield*/, this.getKbList()];
                    case 2:
                        _b.sent();
                        this.AcceptExtension = environment.AcceptUploadFileExtension;
                        this.MaxTotalSizeMB = environment.MaxFileSize;
                        this.initialKB();
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    KnowledgeBaseComponent.prototype.initialKB = function () {
        if (this.knowledgeList != null && this.knowledgeList.length > 0) {
            var i = 0;
            while (this.knowledgeList[i] != null && i < 3) {
                this.showingKBList.push(this.knowledgeList[i]);
                i++;
            }
        }
        this.formatAttachmentName();
    };
    KnowledgeBaseComponent.prototype.newKB = function (event) {
        this.submittedKB = false;
        this.createType = "";
        this.createTitle = "";
        this.createKeyword = "";
        this.createContent = "";
        this.FileList = [];
        this.CreateTableFile();
        $("#createModal").modal("show");
    };
    KnowledgeBaseComponent.prototype.filterByGroup = function (categoryId) {
        this.util.ShowWaiting(true);
        this.Search = "";
        this.showingKBList = this.knowledgeList.filter(function (kb) {
            return categoryId == kb.dpa_categoryid;
        });
        this.formatAttachmentName();
        this.util.ShowWaiting(false);
    };
    KnowledgeBaseComponent.prototype.filterByKeyword = function () {
        var _this = this;
        this.util.ShowWaiting(true);
        if (this.keyword == null || this.keyword.trim().length == 0) {
            this.Search = "";
            this.initialKB();
        }
        else {
            if (this.searchType == "k") {
                this.showingKBList = this.knowledgeList.filter(function (kb) {
                    return (kb.dpa_keyword != null && kb.dpa_keyword.toLowerCase().includes(_this.keyword.toLowerCase()));
                });
            }
            else if (this.searchType == "c") {
                this.showingKBList = this.knowledgeList.filter(function (kb) {
                    return (kb.dpa_content != null && kb.dpa_content.toLowerCase().includes(_this.keyword.toLowerCase()))
                        || (kb.dpa_name != null && kb.dpa_name.toLowerCase().includes(_this.keyword.toLowerCase()));
                });
            }
            else {
                this.showingKBList = this.knowledgeList.filter(function (kb) {
                    return (kb.dpa_keyword != null && kb.dpa_keyword.toLowerCase().includes(_this.keyword.toLowerCase()))
                        || (kb.dpa_content != null && kb.dpa_content.toLowerCase().includes(_this.keyword.toLowerCase()))
                        || (kb.dpa_name != null && kb.dpa_name.toLowerCase().includes(_this.keyword.toLowerCase()));
                });
            }
        }
        this.formatAttachmentName();
        this.Search = this.keyword;
        this.util.ShowWaiting(false);
    };
    KnowledgeBaseComponent.prototype.createKB = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submittedKB = true;
                        if (!(this.createTitle != "")) return [3 /*break*/, 5];
                        this.util.ShowWaiting(true);
                        req = {
                            dpa_knowledgebaseid: null,
                            dpa_name: this.createTitle,
                            dpa_articleno: null,
                            dpa_categoryid: this.createType,
                            dpa_keyword: this.createKeyword,
                            dpa_content: this.createContent,
                            dpa_isdisplayoncustomcrmweb: true,
                            dpa_isdisplayoncustomerportal: false,
                            dpa_createdby: this.cookieData.userId,
                            attachfilelist: this.FileList
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "knowledgeBase", req)];
                    case 1:
                        res = _a.sent();
                        if (!this.util.isSuccessResponse(res)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getKbList()];
                    case 2:
                        _a.sent();
                        $("#createModal").modal('hide');
                        this.util.SuccessDialog("สร้าง Knowledge Base สำเร็จ");
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ErrorDialog("สร้าง Knowledge Base ไม่สำเร็จ");
                        _a.label = 4;
                    case 4:
                        this.util.ShowWaiting(false);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    KnowledgeBaseComponent.prototype.getKbList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "dpa_isdisplayoncustomcrmweb=true&dpa_publishstatus=true&dpa_iscrisis=" + this.isCrisis.toString();
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("master", "knowledgeBase", para)];
                    case 1:
                        _a.knowledgeList = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KnowledgeBaseComponent.prototype.formatAttachmentName = function () {
        var _this = this;
        this.showingKBList.forEach(function (k) {
            if (k.attachfilelist != null && k.attachfilelist.length > 0) {
                var baseUrl_1 = _this.util.baseUrl();
                var att = k.attachfilelist.map(function (a) {
                    return '<a class="mr-3" target="_blank" href="' + baseUrl_1 + '/downloadFile?file=' + a.annotationid + '">' + a.filename + "</a>";
                });
                k.dpa_attch = '<label class="mr-3">ไฟล์แนบ:</label>' + att.join("");
            }
            else {
                k.dpa_attch = '';
            }
        });
    };
    KnowledgeBaseComponent.prototype.ViewFile = function (Url, FileName) {
        if (Url == "") {
            this.util.ErrorDialog('ไม่พบไฟล์ที่เลือก');
            return;
        }
        window.open(this.util.CreateBlobUrl(Url), "_blank");
        // $("#FileNameTitle").html(FileName);
        // $("#ViewDocFrame").attr("src", this.Util.CreateBlobUrl(Url));
        // $('#dlgFile').modal();
        // var link = document.createElement('a');
        // link.href = this.Util.CreateBlobUrl(Url);
        // link.target = "_blank";
        // link.download = FileName;
        // link.click();
        // console.log("click!");
    };
    KnowledgeBaseComponent.prototype.DeleteFile = function (FileName) {
        var _this = this;
        this.FileList.forEach(function (item, index) {
            if (item["filename"] === FileName)
                _this.FileList.splice(index, 1);
        });
        this.CreateTableFile();
    };
    KnowledgeBaseComponent.prototype.FileSelect = function (File) {
        return __awaiter(this, void 0, void 0, function () {
            var FileName, FileExtension, TotalFileSize, FR, FileContent, MimeType, thisTs;
            return __generator(this, function (_a) {
                if (File.length == 0)
                    return [2 /*return*/];
                FileName = File[0]["name"];
                FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length);
                if (!this.AcceptExtension.toLowerCase().includes(FileExtension.toLowerCase())) {
                    this.util.WarningDialog('รองรับเฉพาะไฟล์ ' + this.AcceptExtension);
                    $('#fileAttach').val('');
                    return [2 /*return*/];
                }
                TotalFileSize = File[0]["size"];
                this.FileList.forEach(function (a) {
                    TotalFileSize += +a["filesize"];
                });
                if (TotalFileSize / 1024 / 1024 > this.MaxTotalSizeMB) {
                    this.util.WarningDialog('ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน ' + this.MaxTotalSizeMB + " MB");
                    $('#fileAttach').val('');
                    return [2 /*return*/];
                }
                if (this.FileList != null) {
                    if (this.FileList.filter(function (a) { return a.filename == File[0].name; }).length > 0) {
                        this.util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
                        return [2 /*return*/];
                    }
                }
                FR = new FileReader();
                thisTs = this;
                FR.onload = function (e) {
                    var t = e.target;
                    FileContent = t.result;
                    MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
                    var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);
                    if (thisTs.FileList == null || thisTs.FileList == undefined)
                        thisTs.FileList = [];
                    thisTs.FileList.push({
                        "annotationid": null,
                        "filename": File[0].name,
                        "documentbody": FileContent2,
                        "mimetype": MimeType,
                        "filesize": File[0]["size"],
                        "url": FileContent
                    });
                    $('#fileAttach').val('');
                    // $('#txtFileName').val('');
                    thisTs.CreateTableFile();
                };
                FR.readAsDataURL(File[0]);
                return [2 /*return*/];
            });
        });
    };
    KnowledgeBaseComponent.prototype.UploadFile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var FileInput, File, FileContent, MimeType, thisTs;
            return __generator(this, function (_a) {
                FileInput = $('#fileAttach')[0]["files"];
                if (FileInput.length == 0) {
                    this.util.ErrorDialog('กรุณาเลือกไฟล์');
                    return [2 /*return*/];
                }
                if (this.FileList != null) {
                    if (this.FileList.filter(function (a) { return a.filename == FileInput[0].name; }).length > 0) {
                        this.util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
                        return [2 /*return*/];
                    }
                }
                File = new FileReader();
                thisTs = this;
                File.onload = function (e) { return __awaiter(_this, void 0, void 0, function () {
                    var t, FileContent2;
                    return __generator(this, function (_a) {
                        t = e.target;
                        FileContent = t.result;
                        MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
                        FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);
                        if (thisTs.FileList == null || thisTs.FileList == undefined)
                            thisTs.FileList = [];
                        thisTs.FileList.push({
                            "annotationid": null,
                            "filename": FileInput[0].name,
                            "documentbody": FileContent2,
                            "mimetype": MimeType,
                            "filesize": FileInput[0]["size"],
                            "url": FileContent
                        });
                        $('#fileAttach').val('');
                        $('#txtFileName').val('');
                        thisTs.CreateTableFile();
                        return [2 /*return*/];
                    });
                }); };
                File.readAsDataURL(FileInput[0]);
                return [2 /*return*/];
            });
        });
    };
    KnowledgeBaseComponent.prototype.CreateTableFile = function () {
        var thisTs = this;
        var TableDocs = $('#TableDocs').DataTable({
            "paging": false,
            "bFilter": false,
            "info": false,
            "data": this.FileList,
            "columns": [
                { "data": "filename", "class": "text-center" },
                { "data": "filename" },
                {
                    "data": "null",
                    "render": function (data, type, row) {
                        if (row.filesize / 1024 / 1024 < 1) {
                            return Math.floor(row.filesize / 1024) + ' KB';
                        }
                        else {
                            return (Math.round(row.filesize / 1024 / 1024 * 100 + Number.EPSILON) / 100) + ' MB';
                        }
                    },
                    "class": "text-right"
                },
                {
                    "data": null,
                    "render": function (data, type, row) {
                        return '<i class="fa fa-eye edit-icon mr-2" role="view" url="' + row.url + '" filename="' + row.filename + '" title="View"></i>' +
                            '<i class="fa fa-times delete-icon ml-2" role="delete" filename="' + row.filename + '" title="Delete"></i>';
                    },
                    "class": "col-btn-2 text-center"
                }
            ],
            "language": {
                "zeroRecords": "ยังไม่ได้อัปโหลดไฟล์"
            }
        });
        // TableDocs.on('click', 'tbody tr td [role=view]', function () {
        //   thisTs.ViewFile($(this).attr('url'), $(this).attr('filename'));
        // });
        // TableDocs.on('click', 'tbody tr td [role=delete]', function () {
        //   thisTs.DeleteFile($(this).attr('filename'));
        // });
        TableDocs.on('order.dt search.dt', function () {
            TableDocs.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell, i) {
                cell.innerHTML = i + 1;
            });
        }).destroy().draw();
    };
    return KnowledgeBaseComponent;
}());
export { KnowledgeBaseComponent };



// WEBPACK FOOTER //
// ./src/app/knowledge-base/knowledge-base.component.ts.pre-build-optimizer.js